export const EndpointsConstants = {
  longRequestLimit: 3000,
  requestLimit: 20,
  assemblyOrdersRequestLimit: 20,
  flowRequestLimit: 20,
  sectorRequestLimit: 100,
  tasksRequestLimit: 20,
  plansRequestLimit: 20,
  userRequestLimit: 20,
  selectRequestLimit: 1000,
  return200OnEmpty: 'return_200_on_empty',
  assemblyOrder: {
    base: '/assembly-order',
    all: '/assembly-orders',
    single: '/assembly-orders/{id}',
    orphans: '/assembly-orders/orphans',
    uploadDetails: '/assembly-orders/upload-details'
  },
  auth: {
    login: '/auth',
  },
  admin: {
    all: '/admins',
    single: '/admins/{id}',
    login: '/auth/admin-login'
  },
  categoryIssue: {
    all: '/issue-categories',
    single: '/issue-categories/{id}'
  },
  client: {
    all: '/clients',
    single: '/clients/{id}'
  },
  configuration: {
    all: '/configurations',
    single: '/configurations/{id}'
  },
  dealerships: {
    all: '/dealerships',
    single: '/dealerships/{id}'
  },
  flow: {
    all: '/flows',
    single: '/flows/{id}',
    setOrder: '/flows/set-order'
  },
  holiday: {
    all: '/holidays',
    single: '/holidays/{id}',
    multiple: '/holidays/multiple'
  },
  machine: {
    all: '/machines',
    single: '/machines/{id}'
  },
  machineClient: {
    all: '/machine-client',
    single: '/machine-client/{id}'
  },
  machineSettings: {
    all: '/configurations',
    single: '/configurations/{id}'
  },
  sector: {
    all: '/sectors',
    single: '/sectors/{id}',
    setOrder: '/sectors/set-order'
  },
  seller: {
    all: '/sellers',
    single: '/sellers/{id}'
  },
  user: {
    all: '/users',
    single: '/users/{id}',
    login: '/login',
  },
  task: {
    all: '/tasks',
    single: '/tasks/{id}',
    uploadPlan: '/tasks/upload-plan',
    uploadLabel: '/tasks/upload-label',
    assignConfiguration: '/tasks/{id}/configurations',
    import: '/tasks/import'
  },
  taskIssues: {
    all: '/task-issues',
    single: '/task-issues/{id}',
    uploadImage: '/task-issues/upload-image',
  },
  workplan: {
    base: '/workplan',
    all: '/workplans',
    single: '/workplans/{id}',
    gantt: '/workplans/{id}/gantt',
    finish: '/workplans/{id}/finish',
    adminComment: '/workplans/set-admin-comment',
    setDates: '/workplans/set-dates',
    swap: '/workplans/{idWorkplan}/swap/{idAssemblyOrderOrigin}/{idAssemblyOrderDestination}',
    full: '/workplans/full',
    setStatusMultiple: '/workplans/set-status-multiple'
  },
  taskStocks: {
    all: '/task-stocks',
    single: '/task-stocks/{id}',
    assign: '/task-stocks/assign'
  }
};
